const AuthResponseOidc = () => {
  return null;
};

export default AuthResponseOidc;
